import FrequencySelector from './FrequencySelector'
export default FrequencySelector



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/ServiceSetup/screens/DateTimeForm/components/FrequencySelector/index.js